import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import {
  Button,
  CircularProgress,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { postFetch } from "../../../fetch/fetch";

const GetPassword: React.FC<any> = (props) => {
  const [disabled, setDisabled] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);
  const inputRef2 = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [showPw, setShowPw] = useState(false);
  const [showPw2, setShowPw2] = useState(false);

  // error 상태 (두 비밀번호 불일치)
  const mismatch = useMemo(() => {
    const pw = props.password ?? "";
    const cpw = confirmPassword ?? "";
    // 둘 중 하나라도 입력 중이면서, 둘 다 값이 있고, 다르면 에러
    return pw.length > 0 && cpw.length > 0 && pw !== cpw;
  }, [props.password, confirmPassword]);

  // 길이 체크 (8~20)
  const lengthOk = useMemo(() => {
    const pw = props.password ?? "";
    return pw.length >= 8 && pw.length <= 20;
  }, [props.password]);

  // 일치 체크
  const matchOk = useMemo(() => {
    const pw = props.password ?? "";
    const cpw = confirmPassword ?? "";
    return pw.length > 0 && cpw.length > 0 && pw === cpw;
  }, [props.password, confirmPassword]);

  // 버튼 disabled 조건 갱신
  useEffect(() => {
    // 8~20 + 두 비밀번호 일치해야 활성화
    setDisabled(!(lengthOk && matchOk));

    //둘 다 맞으면 둘 다 blur 처리
    if (lengthOk && matchOk) {
      if (inputRef && inputRef.current) {
        inputRef.current.blur();
      }
      if (inputRef2 && inputRef2.current) {
        inputRef2.current.blur();
      }
    }

  }, [lengthOk, matchOk]);

  const controlChange = (raw: string) => {
    // 20자 이하 제한
    if (raw.length > 20) raw = raw.slice(0, 20);
    props.setPassword?.(raw);
  };

  const controlChangeConfirm = (raw: string) => {
    if (raw.length > 20) raw = raw.slice(0, 20);
    setConfirmPassword(raw);
  };

  const submit = async () => {
    try {

      if(props.hasDeactivatedAccount){

        //서버에 가서 비밀번호 바꾸고 activate 시키자
        setLoading(true);

        const result : any = await postFetch("/signup/activateaccount", {
            phoneNumber: props.phoneNumber,
            password: props.password,
        });

        console.log(result);

        setLoading(false);

        if(result.message === "success"){

            //완료 페이지로 가자
            props.setPage(10);
            return;
        }


      }else if(props.type && props.type === "findpassword"){

        //서버에 가서 비밀번호 바꾸자
        setLoading(true);

        const result : any = await postFetch("/signup/repassword2", {
            phoneNumber: props.phoneNumber,
            rePassword: props.password,
            certNumber : props.certNumber,
        });

        setLoading(false);

        console.log(result);

        if(result.message === "success"){

            //완료 페이지로 가자
            props.setPage(10);
            return;
        }

      }else{

        //이름 물어보는 페이지로 가자
        props.setPage(5);

      }


    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // 처음에 focus 처리
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div
      className={styles.mainContainer}
      style={{
        height: props.bodyHeight ? `${props.bodyHeight}px` : "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: props.pc ? "" : "space-between",
        // paddingBottom: "39px",
        paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
      }}
    >
      <div style={{ width: "100%",
      marginBottom : props.pc ? "30px" : "0px"
       }}>
        <div
          style={{
            paddingTop: "28px",
            color: "#202632",
            fontFamily: "Apple_B",
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "-2%",
          }}
        >
          로그인에 사용할<br />
          비밀번호를 입력해주세요
        </div>

        <div style={{ marginTop: "40px" }}>
          {/* 비밀번호 */}
          <TextField
            variant="standard"
            label="비밀번호"
            placeholder="비밀번호(8자~20자)"
            fullWidth
            type={showPw ? "text" : "password"}
            sx={{
              "& .MuiInput-underline::before": {
                borderBottom: "1px solid #d3d3d3",
              },
              "& .MuiInput-underline": {
                height: "40px",
              },
              "& .MuiInputBase-input::placeholder": {
                fontFamily: "Apple_SB",
                color: "#d3d3d3",
                opacity: 1,
              },
              "& .MuiInputBase-input": {
                fontFamily: "Apple_SB",
                color: "#202632",
                fontSize: "20px",
              },
            }}
            value={props.password ?? ""}
            onChange={(e) => controlChange(e.target.value)}
            inputRef={inputRef}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPw((v) => !v)}
                    edge="end"
                    size="small"
                    aria-label={showPw ? "비밀번호 숨기기" : "비밀번호 보기"}
                    tabIndex={-1}
                  >
                    {showPw ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <div style={{ height: "18px" }} />

          {/* 비밀번호 확인 */}
          <TextField
            variant="standard"
            label="비밀번호 확인"
            placeholder="비밀번호(8자~20자)"
            fullWidth
            type={showPw2 ? "text" : "password"}
            error={mismatch}
            sx={{
              "& .MuiInput-underline::before": {
                borderBottom: "1px solid #d3d3d3",
              },
              "& .MuiInput-underline": {
                height: "40px",
              },
              "& .MuiInputBase-input::placeholder": {
                fontFamily: "Apple_SB",
                color: "#d3d3d3",
                opacity: 1,
              },
              "& .MuiInputBase-input": {
                fontFamily: "Apple_SB",
                color: "#202632",
                fontSize: "20px",
              },
            }}
            value={confirmPassword}
            inputRef={inputRef2}
            onChange={(e) => controlChangeConfirm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPw2((v) => !v)}
                    edge="end"
                    size="small"
                    aria-label={showPw2 ? "비밀번호 숨기기" : "비밀번호 보기"}
                    tabIndex={-1}
                  >
                    {showPw2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {/* 에러 문구 (가운데) */}
          {mismatch && (
            <div
              style={{
                marginTop: "18px",
                textAlign: "center",
                color: "#d32f2f", // MUI error 느낌
                fontSize: "13px",
                fontFamily: "Apple_R",
                letterSpacing: "-0.3px",
              }}
            >
              비밀번호가 일치하지 않습니다
            </div>
          )}



          {/* 길이 안내(원하면 유지) */}
          {!mismatch && (props.password ?? "").length > 0 && !lengthOk && (
            <div
              style={{
                marginTop: "18px",
                textAlign: "center",
                color: "#d32f2f",
                fontSize: "13px",
                fontFamily: "Apple_R",
                letterSpacing: "-0.3px",
              }}
            >
              비밀번호는 8자~20자 사이로 입력해주세요
            </div>
          )}
        </div>
      </div>

      <div>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#3d50b0",
            height: "52px",
            borderRadius: "13px",
            fontWeight: 500,
            fontFamily: "Apple_R",
            boxShadow: "none !important",
            "&.Mui-disabled": {
              backgroundColor: "#C1d6f3",
              color: "white",
            },
            "&:hover": {
              backgroundColor: "#3d50b0",
              boxShadow: "none",
            },
            "&:active": {
              backgroundColor: "#3d50b0",
            },
            "&.Mui-focusVisible": {
              backgroundColor: "#3d50b0",
            },
          }}
          fullWidth
          disabled={disabled || loading}
          onClick={submit}
        >
          {!loading ? "확인" : <CircularProgress size={24} style={{ color: "white" }} />}
        </Button>
      </div>
    </div>
  );
};

export default GetPassword;